<script setup>
defineProps({
    message: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <div v-show="message">
        <p class="text-sm text-red-600 dark:text-red-400">
            {{ message }}
        </p>
    </div>
</template>
